import { getMe, logout } from '../api/client';

export async function mountNav(): Promise<boolean> {
    const nav = document.getElementById('nav');
    if (!nav) return false;
    try {
        const me = await getMe();
        nav.innerHTML = `<span class="nav-user">${escapeHtml(me.username)}</span> <a href="/me">My Pastes</a> <a href="#" id="logout-link">Logout</a>`;
        document.getElementById('logout-link')?.addEventListener('click', async (e) => {
            e.preventDefault();
            try { await logout(); } finally { window.location.href = '/'; }
        });
        return true;
    } catch {
        nav.innerHTML = `<a href="/login">Login</a> <a href="/register">Register</a>`;
        return false;
    }
}

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
